import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { getOthersOffers, getSavedOffers } from "services/offer_service";
import OfferCard from "components/team/OfferCard";
import { mapOfferToCard } from "components/utils/OfferMapping";

function App() {
  const [gamesList, setGamesList] = useState([]);
  const [savedOffers, setSavedOffers] = useState(new Map());

  useEffect(() => {
    async function fetchData() {
      let offerList = await getOthersOffers();

      const offerIdList = offerList.map((a) => a.id);
      const savedOffers = await getSavedOffers(offerIdList);

      offerList.sort((a, b) => {
        return new Date(a.attributes.date) - new Date(b.attributes.date);
      });
      
      setSavedOffers(savedOffers);

      let offers = mapOfferToCard(offerList)
      setGamesList(offers);
    }

    fetchData();
  }, []);

  const canAddOffer = () => {
    if (localStorage.getItem("role") === "Clube") {
      return true;
    }

    return false;
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>

          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/ofertas"}>Vagas</Link>
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Vagas na plataforma</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="columns" style={{display: "block"}}>
            {gamesList?.length > 0 &&
                gamesList.map((el) => (
                  <>
                 <OfferCard
                      id={el.id}
                      createdDate={el.createdAt}
                      title={el.title}
                      subTitle={el.subTitle}
                      division={el.division}
                      savedOfferId={savedOffers.get(el.id)}
                    ></OfferCard>
                  </>
                ))}
            </div>

            {canAddOffer() && (
              <div className="fullwidth flex">
                <Link to={`/ofertas/nova-oferta`} className="marginAuto">
                  <i className="fa fa-plus circled-icon"></i>
                </Link>
              </div>
            )}
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
